export default "__VITE_ASSET__mux$NMAS__"